// /* eslint-disable*/
// import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   BarElement,
//   CategoryScale,
//   LinearScale,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import './QuerterwiseChart.css';

// ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ChartDataLabels);

// const QuerterwiseChart = ({ labels, datasets }) => {
//   const data = {
//     labels,
//     datasets,
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: {
//         anchor: 'top',
//         align: 'top',
//         color: '#333',
//         font: {
//           weight: 'bold',
//         },
//         formatter: (value) => (value > 0 ? value : ''),
//       },
//       legend: {
//         position: 'top',
//       },
//       tooltip: {
//         mode: 'index',
//         intersect: false,
//       },
//     },
//     scales: {
//       x: {
//         stacked: false,
//         ticks: {
//           font: {
//             size: 12,
//           },
//         },
//       },
//       y: {
//         stacked: false,
//         beginAtZero: true,
//         ticks: {
//           stepSize: 50,
//         },
//         title: {
//           display: true,
//           text: 'FTEs Counts',
//           font: {
//             size: 14,
//           },
//         },
//       },
//     },
//   };

//   return (
//     <div className="multi-bar-chart">
//       <Bar data={data} options={options} plugins={[ChartDataLabels]} />
//     </div>
//   );
// };

// export default QuerterwiseChart;


//  ############## new code ################
/* eslint-disable */
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import './QuerterwiseChart.css';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ChartDataLabels);

const QuerterwiseChart = ({ labels, datasets }) => {
  const datasetsWithRadius = datasets.map(ds => ({
    ...ds,
    borderRadius: {
      topLeft: 7,
      topRight: 7,
      bottomLeft: 0,
      bottomRight: 0,
    },
    borderSkipped: false,
  }));

  const data = {
    labels,
    datasets: datasetsWithRadius,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        color: '#333',
        font: {
          weight: 'bold',
        },
        formatter: (value) => (value > 0 ? value : ''),
      },
      legend: {
        position: 'bottom',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        stacked: false,
        ticks: {
          font: {
            size: 12,
          },
        },
      },
      y: {
        stacked: false,
        beginAtZero: true,
        ticks: {
          stepSize: 50,
        },
        title: {
          display: true,
          text: 'FTEs Counts',
          font: {
            size: 14,
          },
        },
      },
    },
  };

  return (
    <div className="multi-bar-chart">
      <Bar data={data} options={options} plugins={[ChartDataLabels]} />
    </div>
  );
};

export default QuerterwiseChart;
